<template>
    <v-btn @click="shareOnFacebook" class="mr-3" variant="outlined" color="#CFD6EA" icon="mdi-facebook" rounded="lg"><template v-slot:default><v-icon color="#1877F2"></v-icon></template></v-btn>
    <v-btn @click="shareOnTwitter" class="mr-3" variant="outlined" color="#CFD6EA" icon="mdi-twitter" rounded="lg"><template v-slot:default><v-icon color="#1DA1F2"></v-icon></template></v-btn>
    <v-btn class="mr-3" variant="outlined" color="#CFD6EA" icon="mdi-instagram" rounded="lg"><template v-slot:default><v-icon color="black"></v-icon></template></v-btn>
</template>
<script>
export default {
    name: "SocialButtons",
    props: {
        url: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            referralMessage: this.$t('referrers.social message')
        };
    },
    methods: {
        shareOnFacebook() {
            const facebookShareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.url)}`;
            window.open(facebookShareURL, '_blank','width=600,height=400');
        },
        shareOnTwitter() {
            const tweetText = `${this.referralMessage} ${encodeURIComponent(this.url)}`;
            const twitterShareURL = `https://twitter.com/intent/tweet?text=${tweetText}`;
            window.open(twitterShareURL, '_blank', 'width=600,height=400');
        }
    }
}
</script>
